// import { data } from "isotope-layout";
import PropTypes from "prop-types";
import React from 'react';
// import {Link} from "react-router-dom";
// import FileName from '../../data/pic/filename.json';



const WorkDetailsContainer = () => {
    // const cate = data.categories.map((value, i) => {
    //     return(
    //         <span className="d-inline" key={i}>{value}{i !== data.categories.length - 1 && " , "}</span>
    //     )
    // })
    return (
        <div className="section section-padding">
    <div className="container">
        <div className="row pt--100 pb--80">
            <div className="col-lg-4 col-md-6 col-12">
                <div className="work-left work-details" data-aos="fade-up">
                    <div className="portfolio-main-info">
                        <h2 className="title">Wonderful Moments </h2>
                        <div className="work-details-list mt-12">
                            <div className="details-list">
                                <label>Years</label>
                                <span>2025</span>
                            </div>
                            <div className="details-list">
                                <label>Date</label>
                                <span>11th-15th, July</span>
                            </div>
                            <div className="details-list">
                                <label>Location</label>
                                <span>Yokohama, Japan</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-7 col-md-6 offset-lg-1 col-12">
                <div className="work-left work-details mt-6">
                    <div className="work-main-info">
                        <div className="work-content">
                            <h4 className="title" data-aos="fade-up">The Sixteenth International Conference on Swarm Intelligence (ICSI&apos;2025)</h4>
                            <div className="desc mt-8">
                                <p>
                                    Yokohama, Japan - The Sixteenth International Conference on Swarm Intelligence (ICSI&apos;2025) was successfully held in Yokohama on July 11th-15th, 2025. The conference brought together leading researchers, practitioners, and academics from around the world to explore the latest trends and advancements in swarm intelligence.
                                </p>
                                <p>
                                    The theme of ICSI&apos;2025 is &quot;Serving Life with Swarm Intelligence&quot;. The ICSI&apos;2025 provided an excellent opportunity and/or an academic forum for academics and practitioners to present and discuss the latest scientific results and methods, innovative ideas, and advantages in theories, technologies, and applications in swarm intelligence. The technical program covered a number of aspects of swarm intelligence and its related areas.
                                </p>
                                <p>
                                    The five-day conference featured keynote speeches, technical sessions, oral presentations, and workshops, covering a wide range of topics related to swarm intelligence, including swarm robotics, swarm optimization, swarm intelligence in social systems, and more. The conference also provided an excellent opportunity for researchers and practitioners to exchange ideas, network, and collaborate on new research projects.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="row mt-lg-20 mt-12">
            <div className="col-lg-4 col-md-12 col-12">
                <div className="digital-marketing" data-aos="fade-up">
                    <h3 className="heading heading-h3">Opening Ceremony</h3>
                </div>
            </div>
            <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                    <div className="inner">
                        <p>The conference was inaugurated on July 11th at 8:30 AM, presided over by Prof. Lijiacheng. Following the commencement, conference chair Prof. Ying Tan delivered the opening speech. Prof. Tan reported on the current status of this year&apos;s conference and extended a warm welcome to everyone. Prof. Masato Noto from Kanagawa University also gave an opening speech, welcoming all participants.</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-12">
                <div className="custom-column-thumbnail mt-lg-14 mt-1" data-aos="fade-up">
                    <img className="w-50" src='./images/gallery/li.jpg' alt="Prof. Lijiacheng" />
                    <img className="w-50" src='./images/gallery/tan.jpg' alt="Prof. Ying Tan" />
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-12">
                <div className="custom-column-thumbnail mt-lg-14 mt-1" data-aos="fade-up">
                    <img  src='./images/gallery/noto.jpg' alt="Prof. noto" />
                    <br/>
                    <img  src='./images/gallery/all.jpg' alt="all" />
                </div>
            </div>
        </div>
        <div className="row mt-lg-20 mt-12">
            <div className="col-lg-4 col-md-12 col-12">
                <div className="digital-marketing" data-aos="fade-up">
                    <h3 className="heading heading-h3">Plenary Speech I</h3>
                </div>
            </div>
            <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                    <div className="inner">
                        <p>Prof. Masanori Akiyoshi from Kanagawa University presented a comprehensive exploration of swarm intelligence and multi-agent optimization. He discussed the differences between these approaches and their applications in solving complex problems. Prof. Akiyoshi also highlighted the intersection between swarm intelligence, multi-agent optimization, and artificial intelligence, providing insights into the broader trends in intelligence research.</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="custom-layout-gallery mt-lg-20 mt-12">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/aki.jpg" alt="Prof. Masanori Akiyoshi" />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/aki2.jpg" alt="Prof. Masanori Akiyoshi" />
                    </div>
                </div>
            </div>
        </div>
        <div className="row mt-lg-20 mt-12">
            <div className="col-lg-4 col-md-12 col-12">
                <div className="digital-marketing" data-aos="fade-up">
                    <h3 className="heading heading-h3">Plenary Speech II</h3>
                </div>
            </div>
            <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                    <div className="inner">
                        <p>Prof. Nobuo Kawaguchi from Nagoya University discussed the digitization and visualization for smart environments towards digital twin-driven optimization. He emphasized the practical and societal applications of swarm intelligence in developing smart city technologies and next-generation mobility systems.</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="custom-layout-gallery mt-lg-20 mt-12">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/kawaguchi.jpg" alt="Prof. Nobuo Kawaguchi" />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/kawaguchi2.jpg" alt="Prof. Nobuo Kawaguchi" />
                    </div>
                </div>
            </div>
        </div>
        <div className="row mt-lg-20 mt-12">
            <div className="col-lg-4 col-md-12 col-12">
                <div className="digital-marketing" data-aos="fade-up">
                    <h3 className="heading heading-h3">Plenary Speech III</h3>
                </div>
            </div>
            <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                    <div className="inner">
                        <p>Prof. Yuji Sato from Hosei University presented on evolutionary computation as reinforcement learning and multi-objective PSO. He explained the application of evolutionary computation in solving large-scale combinatorial optimization problems and introduced multi-objective particle swarm optimization (MOPSO).</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="custom-layout-gallery mt-lg-20 mt-12">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/sato.jpg" alt="Prof. Yuji Sato" />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/sato2.jpg" alt="Prof. Yuji Sato" />
                    </div>
                </div>
            </div>
        </div>
        <div className="row mt-lg-20 mt-12">
            <div className="col-lg-4 col-md-12 col-12">
                <div className="digital-marketing" data-aos="fade-up">
                    <h3 className="heading heading-h3">Plenary Speech IV</h3>
                </div>
            </div>
            <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                    <div className="inner">
                        <p>Dr. Jia Guo from Nagoya University discussed adaptive swarm intelligence and its applications in bridging virtual models and robotic reality. He highlighted the challenges in transferring learning principles from computational environments to physical systems and the potential of swarm intelligence in neural network optimization.</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="custom-layout-gallery mt-lg-20 mt-12">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/guo.jpg" alt="Dr. Jia Guo" />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/guo2.jpg" alt="Dr. Jia Guo" />
                    </div>
                </div>
            </div>
        </div>
        <div className="row mt-lg-20 mt-12">
            <div className="col-lg-4 col-md-12 col-12">
                <div className="digital-marketing" data-aos="fade-up">
                    <h3 className="heading heading-h3">Parallel Sessions</h3>
                </div>
            </div>
            <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                    <div className="inner">
                        <p>The conference continued on July 12th and the morning of July 13th with paper presentations by participating authors spread across three online and three offline conference rooms. Attendees chose sessions based on their interests, leading to engaging conversations and fruitful interactions with the presenters.</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="custom-layout-gallery mt-lg-20 mt-12">
            <div className="row">
                <div className="col-lg-4 col-md-4 col-12">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/p1.jpg" alt="Parallel Session" />
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-12">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/p2.jpg" alt="Parallel Session" />
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-12">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/p3.jpg" alt="Parallel Session" />
                    </div>
                </div>
            </div>
        </div>
        <div className="custom-layout-gallery mt-lg-20 mt-12">
            <div className="row">
                <div className="col-lg-4 col-md-4 col-12">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/p4.jpg" alt="Parallel Session" />
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-12">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/p5.jpg" alt="Parallel Session" />
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-12">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/p6.jpg" alt="Parallel Session" />
                    </div>
                </div>
            </div>
        </div>
        <div className="row mt-lg-20 mt-12">
            <div className="col-lg-4 col-md-12 col-12">
                <div className="digital-marketing" data-aos="fade-up">
                    <h3 className="heading heading-h3">Award Ceremony</h3>
                </div>
            </div>
            <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                    <div className="inner">
                        <p>On the evening of July 12th, a welcome dinner was held at the 21st-floor restaurant of the university, marking a festive occasion where the winners of the Best Paper and Best Student Paper were announced and awarded. Prof. Ying Tan and Prof. Yuhui Shi took a group photo with the winners.</p>
                    </div>
                </div>
            </div>
        </div>
        <div className="custom-layout-gallery mt-lg-20 mt-12">
            <div className="row">
                <div className="col-lg-4 col-md-4 col-12">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/a1.jpg" alt="Award Ceremony" />
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-12">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/a2.jpg" alt="Award Ceremony" />
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-12 mt-lg-0 mt-md-0 mt-10">
                    <div className="thumbnail" data-aos="fade-up">
                        <img className="w-100" src="./images/gallery/a3.jpg" alt="Award Ceremony" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    )
}

WorkDetailsContainer.propTypes = {
    data: PropTypes.object
};

export default WorkDetailsContainer;
